import React from "react";
import { Button } from "react-bootstrap";

export default function AnalyzeButton({ disabled, label = "Analyze", variant = "ra-yellow" }) {
    return (
        <Button type="submit" variant={variant} className="text-uppercase px-5 py-1" disabled={disabled}>
            {label}
        </Button>
    );
}
